(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dingdesire-product-landing"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-dd-section]').forEach((root) => {
    if (root.dataset.ddReady === 'true') return;
    root.dataset.ddReady = 'true';
    const currency = root.dataset.currency || 'USD';
    const formatMoney = (cents) => new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(Number(cents) / 100);
    const price = root.querySelector('[data-dd-price]');
    const compare = root.querySelector('[data-dd-compare]');
    const quantityInput = root.querySelector('[data-dd-quantity]');
    const variantSelect = root.querySelector('[data-dd-variant]');
    const packProduct = root.dataset.packProduct === 'true';
    const variantInput = root.querySelector('[data-dd-variant-input]');
    const signalInput = root.querySelector('[data-dd-signal-input]');
    let unitPrice = Number(root.dataset.initialPrice || 0);
    let quantity = 1;
    const updateTotals = () => {
      if (!packProduct) root.querySelectorAll('[data-dd-bundle-total]').forEach((node) => { node.textContent = formatMoney(unitPrice * Number(node.dataset.quantity)); });
      root.querySelectorAll('[data-dd-button-price]').forEach((node) => { node.textContent = formatMoney(unitPrice * quantity); });
    };
    root.querySelectorAll('[data-dd-thumb]').forEach((button) => button.addEventListener('click', () => {
      root.querySelectorAll('[data-dd-thumb]').forEach((item) => { item.classList.remove('is-active'); item.setAttribute('aria-pressed', 'false'); });
      button.classList.add('is-active');
      button.setAttribute('aria-pressed', 'true');
      const image = root.querySelector('.dd-main-image');
      image.style.opacity = '0';
      const revealImage = () => { image.style.opacity = '1'; image.onload = null; };
      image.onload = revealImage;
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = button.dataset.imageSrc;
      image.alt = button.dataset.imageAlt;
      if (image.complete) revealImage();
    }));
    root.querySelectorAll('[data-dd-chip]').forEach((button) => button.addEventListener('click', () => {
      root.querySelectorAll('[data-dd-chip]').forEach((item) => { item.classList.remove('is-selected'); item.setAttribute('aria-pressed', 'false'); });
      button.classList.add('is-selected');
      button.setAttribute('aria-pressed', 'true');
      signalInput.value = button.dataset.signalValue;
    }));
    root.querySelectorAll('[data-dd-bundle]').forEach((button) => button.addEventListener('click', () => {
      root.querySelectorAll('[data-dd-bundle]').forEach((item) => { item.classList.remove('is-selected'); item.setAttribute('aria-checked', 'false'); });
      button.classList.add('is-selected');
      button.setAttribute('aria-checked', 'true');
      if (packProduct) {
        quantity = 1;
        quantityInput.value = 1;
        variantInput.value = button.dataset.variantId;
        unitPrice = Number(button.dataset.price);
        price.textContent = formatMoney(unitPrice);
        compare.classList.add('is-hidden');
        const available = button.dataset.available === 'true';
        root.querySelectorAll('[data-dd-submit], [data-dd-sticky-submit]').forEach((submit) => { submit.disabled = !available; });
      } else {
        quantity = Number(button.dataset.quantity);
        quantityInput.value = quantity;
      }
      updateTotals();
    }));
    variantSelect?.addEventListener('change', () => {
      const option = variantSelect.selectedOptions[0];
      unitPrice = Number(option.dataset.price);
      const comparePrice = Number(option.dataset.compare);
      price.textContent = formatMoney(unitPrice);
      compare.textContent = comparePrice ? formatMoney(comparePrice) : '';
      compare.classList.toggle('is-hidden', comparePrice <= unitPrice);
      const available = option.dataset.available === 'true';
      root.querySelectorAll('[data-dd-submit], [data-dd-sticky-submit]').forEach((button) => { button.disabled = !available; });
      updateTotals();
    });
    root.querySelectorAll('.dd-faq details').forEach((item) => item.addEventListener('toggle', () => {
      if (item.open) root.querySelectorAll('.dd-faq details').forEach((other) => { if (other !== item) other.open = false; });
    }));
    root.querySelectorAll('.dd-buy-form').forEach((form) => form.addEventListener('submit', async (event) => {
      const cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer || typeof cartDrawer.renderContents !== 'function') return;
      event.preventDefault();
      const submitter = event.submitter;
      const errorNode = form.querySelector('[data-dd-cart-error]');
      if (errorNode) {
        errorNode.hidden = true;
        errorNode.textContent = '';
      }
      if (submitter) {
        submitter.disabled = true;
        submitter.setAttribute('aria-busy', 'true');
      }
      try {
        const formData = new FormData(form);
        const sections = cartDrawer.getSectionsToRender().map((section) => section.id);
        formData.append('sections', sections);
        formData.append('sections_url', window.location.pathname);
        cartDrawer.setActiveElement(document.activeElement);
        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        });
        const state = await response.json();
        if (!response.ok || state.status) throw new Error(state.description || state.message || 'Unable to add this item.');
        cartDrawer.classList.remove('is-empty');
        cartDrawer.renderContents(state);
      } catch (error) {
        if (errorNode) {
          errorNode.textContent = error.message;
          errorNode.hidden = false;
        }
      } finally {
        if (submitter) {
          submitter.disabled = false;
          submitter.removeAttribute('aria-busy');
        }
      }
    }));
    const sticky = root.querySelector('[data-dd-sticky]');
    const buyPanel = root.querySelector('[data-dd-buy-panel]');
    if (sticky && buyPanel && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting), { threshold: 0.12 }).observe(buyPanel);
    }
    updateTotals();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
